module.exports = __webpack_public_path__ + "img/wiezhi.e3558ad1.jpeg";